<template>
    <Admin
        :title="__('Shipping edit', null, $page.props.profile_locale)"
    >
    <form @submit.prevent="updateShipping" class="grid sm:grid-cols-2 gap-3">
        <InputLabel
            :label="__('Name', null, $page.props.profile_locale)"
            v-model="form.shipping.name"
        />
        <InputLabel
            :label="__('Slug', null, $page.props.profile_locale)"
            v-model="form.shipping.slug"
        />
        <!-- <InputLabel
            :label="__('Price')"
            type="number"
            v-model="form.shipping.price"
        /> -->

        <div class="col-span-2">
            <img :src="form.image ? image : delivery.image" class="w-40 rounded-md shadow-md p-2 mb-4">
            <InputLabel
                    type="file"
                    class="md:w-1/2 mb-3"
                    v-model="form.image"
                />
        </div>

        <div class="col-span-2">
            <Button
                padding="md"
                :class="[
                    form.isDirty ? '' : 'opacity-50'
                ]"
            >{{__('Update', null, $page.props.profile_locale)}}</Button>
        </div>
    </form>
    </Admin>
</template>

<script>
    import Admin from '@/Layouts/Admin';
    import InputLabel from 'UI/InputLabel';

    import { useForm } from '@inertiajs/inertia-vue3';
    import Button from 'UI/Button';
    // import ImageUpload from 'UI/ImageUploadNew';
    import { ref } from '@vue/reactivity';
import { watch } from '@vue/runtime-core';

    export default {
        props: {
            delivery: [Object, Array],
        },
        components: {
            Admin,
            InputLabel,
            Button,
            // ImageUpload,
        },
        setup(props) {

            const form = useForm({
                shipping: props.delivery,
                image: null,
            });

            const image = ref(null);

            watch(() => form.image, (val) => {
                if(val) getImage(val)
            })
            function getImage(file){
                var FR = new FileReader();
                FR.addEventListener("load", function(e) {
                    image.value = e.target.result;
                });
                FR.readAsDataURL( file );
            }

            function updateShipping() {
                form.post(route('dashboard.admin.shipping.update', props.delivery.id), {
                    preserveScroll: true,
                    onSuccess: (e) => {

                    },
                })
            }

            return {
                form,
                image,
                updateShipping,
            }
        }
    }
</script>
